import { AlertIcon } from '@approvalmax/ui';
import { Alert, Fade } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Role } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { schema } from '../../schema';
import { messages } from './Notice.messages';

export const Notice = memo(() => {
    const { formState } = useFormContext();

    const persons = useWatch<z.infer<typeof schema>, 'people.persons'>({ name: 'people.persons' });

    const atLeastOneDirector = useMemo(
        () => (persons ?? []).some((person) => person.roles.includes(Role.director)),
        [persons]
    );

    if (formState.disabled) {
        return null;
    }

    return (
        <Fade in={!atLeastOneDirector}>
            <Alert
                data-qa='at-least-one-director-required-notice'
                alignItems='center'
                color='midnight20'
                size='small'
                startIcon={<AlertIcon />}
            >
                {messages.notice}
            </Alert>
        </Fade>
    );
});

Notice.displayName = 'Notice';
